//JavaScript Document
import React, { Component, Fragment } from "react";

import { Carousel, Modal, Button, message } from "antd";
import { Link } from "react-router-dom";
import {
	root,
	systemManagerTobRest,
	requestWithSignInJson,
	getAccessPage,
	loginUrl,
	axios,
} from "../../api";
import moment from "moment";
const dateFormat = "YYYY-MM-DD";
class HomePage extends Component {
	constructor() {
		super();
		this.state = {
			mainMenuList: [
				{
					id: "",
					name: "智家大脑",
					key: "KPIReport",
					desc: "大脑平台能力体验运营分析，全面评估智家大脑平台技术能力和智家大脑产品服务的用户体验。",
				},
				{
					id: "",
					name: "用户运营",
					key: "userOperate",
					desc: "围绕用户全生命周期，应用事件分析、留存分析等多种分析模型，进行用户精细化运营。",
				},
				{
					id: "",
					name: "网器运营",
					key: "netDeviceOperate",
					desc: "全流程呈现网器运营指标，为各产业网器发展、功能分析、产品和场景迭代提供支撑服务。",
				},
				{
					id: "",
					name: "标签工厂",
					key: "labelFactory",
					desc: "结合业务需求，可视化构建智慧家庭标签体系，多维度划分用户群体，精准筛选。",
				},
				// {
				//   id: "",
				//   name: "智能服务",
				//   key: "smartServise",
				//   desc: "基于全屋感知数据，为用户提供个性化的主动服务，实现用户体验的千人千面。",
				// },
				// {
				//   id: "",
				//   name: "全屋感知",
				//   key: "dataShare",
				//   desc: "了解感知数据能力布局，评估产品感知价值、评估场景感知能力，支撑场景和产品迭代创新。",
				// },
				{
					id: "",
					name: "智能数据分析",
					key: "intelligentDataAnalysis",
					desc: "基于GPT模型能力的智能数据分析平台，为您提供更加智能、快捷的分析工具。",
				},
				{
					id: "",
					name: "智能服务",
					key: "smartServise",
					desc: "了解感知数据能力布局，并基于感知数据，为用户提供主动服务能力。",
				},
				{
					id: "",
					name: "数据中心",
					key: "dataCenter",
					desc: "数据指标管理，包括数据规划、治理与校验，有效提升数据管理效率。",
				},
				{
					id: "",
					name: "数据工厂",
					key: "dataFactory",
					desc: "通用的数据模型，灵活分析工具的集成，为业务提供自助分析能力。",
				},
			],
			bigdataMenuList: [
				{
					id: "",
					name: "空调大数据",
					key: "airCondition-bigdata",
					labels: ["空调节能", "设备管理", "功能画像"],
					desc: "空调能耗、高峰分析，设备运行曲线、设备功能画像等",
				},
				// {
				//   id: "",
				//   name: "电热大数据",
				//   key: "heater-bigdata",
				//   labels: ["用水时长", "设备状态", "加热分析"],
				//   desc: "电热水器用水、用电、加热、夜电、温度设置分析。",
				// },
				{
					id: "",
					name: "厨电大数据",
					key: "kitchenAppliances-bigdata",
					labels: ["一键烘焙", "菜谱分析", "功能占比"],
					desc: "厨电网器功能分析、菜谱一键烘焙，食联商品销量等分析。",
				},
				{
					id: "",
					name: "冰冷大数据",
					key: "icebox-bigdata",
					labels: ["用户画像", "故障分析", "运行曲线"],
					desc: "冰冷用户画像、饮食偏好、影音偏好等",
				},
				// {
				//   id: "",
				//   name: "洗衣机大数据",
				//   key: "washMachine-bigdata",
				//   labels: ["烘干专题", "启动来源", "用户行为"],
				//   desc: "洗衣机用户行为、交互端活跃、启动来源、烘干分析等",
				// },
				// {
				//   id: "",
				//   name: "全屋智慧",
				//   key: "uhome-bigdata",
				//   labels: ["经营分析", "活跃分析", "离线分析"],
				//   desc: "全屋智慧平台，销售、绑定、在线、活跃、离线等经营指标分析。",
				// },
			],
			notifies: [],
			indexes: [`平台在线用户数:${100 + parseInt(Math.random() * 100)}`],
			overview: [
				{
					count: "200+",
					name: "数据报表",
				},
				{
					count: "100+",
					name: "指标",
				},
				{
					count: "260+",
					name: "标签",
				},
			],
		};
	}
	render() {
		return (
			<Fragment>
				<div className="carousel">
					<Carousel autoplay effect="fade">
						<div className="c1">
              <div>
                <div style={{color: "red",marginBottom: 20,fontSize: 20}}>智家场景体验运营平台下线说明</div>
								<Button type="primary" ghost onClick={() => this.handleClick()}>
									查看详情
								</Button>
              </div>
						</div>
						{/* <div className="c1">
              <span className="title">
                数据辅助业务决策
                <span className="subTitle">
                  还原业务全生命周期提升商业洞察力
                </span>
              </span>
            </div>
            <div className="c2">
              <span className="title">
                数据赋能智慧生活X.0
                <span className="subTitle">
                  引领智慧家庭进入美好生活定制时代
                </span>
              </span>
            </div>
            <div className="c3">
              <span className="title">
                数据驱动物联生态战略落地
                <span className="subTitle">推进智慧生态圈广泛布局</span>
              </span>
            </div> */}
					</Carousel>
				</div>
				<div className="notify">
					<div className="landscape">
						<div className="scrollContainer">
							<div className="scrollContent">
								{this.state.notifies.map((item, index) => {
									let link = `/notifyDetail/${encodeURIComponent(
										item.content
									)}`;
									return (
										<Link to={link} key={index}>
											<img
												className="miniIcon"
												src={`/lifecyclemp/assets/images/${
													item.type == 1 ? "notice" : "announcement"
												}.png`}
												alt=""
											/>
											<span>{item.title}</span>
										</Link>
									);
								})}
							</div>
						</div>
						<Link to="/notifyList" className="readMore">
							查看更多 &gt;
						</Link>
					</div>
					{/* <div className="portrait">
            {this.state.indexes.map((item, index) => (
              <div className="indexItem" key={index}>
                <img
                  src={`/lifecyclemp/assets/images/index.png`}
                  alt=""
                  className="miniIcon"
                />
                <span>{item}</span>
              </div>
            ))}
          </div> */}
				</div>
				<h3 className="moduleTitle">快捷入口</h3>
				<div className="mainMenu">
					{this.state.mainMenuList.map((menuItem) => (
						<div
							className="box translateY"
							key={menuItem.key}
							onClick={() => this.gotoSubPage(menuItem.id)}>
							<div className="fill">
								<div className="text animate__swing">{menuItem.desc}</div>
							</div>
							<div className="inside">
								<img
									className="mainMenuLogo"
									src={`/lifecyclemp/assets/images/${menuItem.key}.png`}
									alt=""
								/>
								<div>{menuItem.name}</div>
							</div>
						</div>
					))}
				</div>
				<div className="bigdataMenuContainer">
					<h3 className="moduleTitle">产业大数据</h3>
					<div className="bigdataMenu">
						{this.state.bigdataMenuList.map((menuItem) => (
							<div
								className="bigdataItem "
								key={menuItem.key}
								onClick={() => this.gotoSubPage(menuItem.id)}>
								<div className="BDheader">
									<img
										className="BDLogo"
										src={`/lifecyclemp/assets/images/${menuItem.key}.png`}
										alt=""
									/>
									<span className="BDMenuTitle">{menuItem.name}</span>
								</div>
								<p>{menuItem.desc}</p>
								<div className="BDLabelContainer">
									{menuItem.labels.map((label, index) => (
										<span className="DBLabel" key={index}>
											{label}
										</span>
									))}
								</div>
							</div>
						))}
					</div>
				</div>
				<div className="case">
					<div className="caseContainer">
						<div className="caseTitle">优秀案例</div>
						<div className="caseBody">
							<img
								src="/lifecyclemp/assets/images/smartfamily.png"
								alt=""
								className="smartfamily"
							/>
							<span className="caseContent">
								<p style={{ fontSize: "24px" }}>智慧互联，一键尽享各地美味</p>
								现在很多年轻人不会做菜，厨电产业通过大数据平台获取各地美食菜谱，在设备屏端，可根据冰箱里的食材，智能为用户推荐菜谱。还可以联动智能烤箱实现一键烘焙，只需在屏端选定烘培食谱并启动，烤箱接收命令便按照食谱设定的温度、时间自动匹配烘烤程序，你要做的就是摆好碗筷，享受家人赞赏的眼神。
							</span>
						</div>
					</div>
				</div>
				<div className="overview">
					{this.state.overview.map((item, index) => (
						<div className="overviewItem" key={index}>
							<span className="overviewCount">{item.count}</span>
							<span className="overviewName">{item.name}</span>
						</div>
					))}
				</div>
				<footer>
					<div className="footer">
						<div>
							<img
								src="/lifecyclemp/assets/images/logoNew.png"
								alt=""
								height="40"
							/>
							<h3 className="f-title">智家场景体验运营平台</h3>
						</div>
						<div className="links">
							<dl>
								<dt>
									<a href="#">首页</a>
								</dt>
							</dl>
							<dl>
								<dt>产品</dt>
								<dd>
									<a
										href={`${location.origin}/lifecyclemp/build/index.html#/`}
										target="_blank">
										智家场景体验运营平台
									</a>
								</dd>
								<dd>
									<a
										href={`${location.origin}/smart-skillmp/build/index.html`}
										target="_blank">
										技能管理平台
									</a>
								</dd>
								<dd>
									<a
										href={`${location.origin}/recommendsys/`}
										target="_blank">
										智能推荐平台
									</a>
								</dd>
								<dd>
									<a
										href={`${location.origin}/smart-knowledgegraph/build/index.html`}
										target="_blank">
										智家大脑平台
									</a>
								</dd>
								<dd>
									<a
										href={`${location.origin}/unicorneye/#/`}
										target="_blank">
										智家统一开发平台
									</a>
								</dd>
							</dl>
							<dl>
								<dt>友情链接</dt>
								<dd>
									<a href="http://www.haier.net/" target="_blank">
										海尔集团
									</a>
								</dd>
								<dd>
									<a
										href="https://www.haier.com/markets/zhijiaapp/"
										target="_blank">
										海尔智家
									</a>
								</dd>
								<dd>
									<a
										href="https://www.haigeek.com/web/pages/haigeek.html"
										target="_blank">
										海极网
									</a>
								</dd>
							</dl>
						</div>
						<dl>
							<dt>关注我们</dt>
							<dd className="float-left" style={{ marginRight: 28 }}>
								<img
									src={`/lifecyclemp/assets/images/weixin.jpg`}
									alt=""
									width="108"
									height="108"
								/>
								<p className="align-center">公众号</p>
							</dd>
							<dd className="float-left">
								<img
									src={`/lifecyclemp/assets/images/weibo.jpg`}
									alt=""
									width="108"
									height="108"
								/>
								<p className="align-center">微博</p>
							</dd>
						</dl>
					</div>
					<p className="align-center">
						{`Copyright © ${new Date().getFullYear()}     海尔U+版权所有      鲁ICP备14026385号-2`}
					</p>
				</footer>
			</Fragment>
		);
	}
	componentDidMount() {
		// this.getMenu();
		this.getNotify();
	}
  handleClick=()=>{
    window.open("https://ihaier.feishu.cn/wiki/Pku3wd0HJifq1LkaZuoc4E52nRc");
  }
	getMenu = (callback) => {
		if (!localStorage.getItem("lifecyclemp-Access-User-Token")) {
			return;
		}
		requestWithSignInJson({
			method: "POST",
			url: `${systemManagerTobRest}/user/getPermissions`,
			data: {
				sysCode: "lifecyclemp",
			},
			accessPage: getAccessPage({
				module: "首页",
				operation: "query",
			}),
		})
			.then((resp) => {
				let { retCode, data } = resp;

				if (retCode == 0) {
					let { dimPermissions, menuPermissions } = data;
					let entryMenu = new Map();
					let moduleMenu = {};
					let groupMenu = {};
					let pageMenu = {};
					let modulePermission = new Array();

					for (let i = 0; i < menuPermissions.length; i++) {
						let item = menuPermissions[i];
						if (item.menuType == 1) {
							switch (item.menuLevel) {
								case 2:
									entryMenu.set(item.menuCode, item.id);
									break;
								case 3:
									let module = moduleMenu[item.parentId] || [];
									module.push(item);
									moduleMenu[item.parentId] = module;
									break;
								case 4:
									let group = groupMenu[item.parentId] || [];
									group.push(item);
									groupMenu[item.parentId] = group;
									break;
								case 5:
									let { menuUrl: url } = item;
									if (url.charAt(0) != "/") {
										item.menuUrl =
											url.indexOf("?") > 0
												? `${url}&token=${window.localStorage.getItem(
														"lifecyclemp-Access-User-Token"
												  )}`
												: `${url}?token=${window.localStorage.getItem(
														"lifecyclemp-Access-User-Token"
												  )}`;
									}
									let page = pageMenu[item.parentId] || [];
									page.push(item);
									pageMenu[item.parentId] = page;
									break;
								default:
									break;
							}
						} else if (item.menuType == 2) {
							modulePermission.push(item);
						}
					}
					let { mainMenuList, bigdataMenuList } = this.state;
					mainMenuList.forEach((item) => (item.id = entryMenu.get(item.key)));
					bigdataMenuList.forEach(
						(item) => (item.id = entryMenu.get(item.key))
					);
					this.setState({ mainMenuList, bigdataMenuList });
					window.localStorage.setItem(
						"lifecyclemp-dimPermissions",
						JSON.stringify(dimPermissions)
					);
					window.localStorage.setItem(
						"lifecyclemp-modulePermission",
						JSON.stringify(modulePermission)
					);
					window.localStorage.setItem(
						"lifecyclemp-moduleMenu",
						JSON.stringify(moduleMenu)
					);
					window.localStorage.setItem(
						"lifecyclemp-groupMenu",
						JSON.stringify(groupMenu)
					);
					window.localStorage.setItem(
						"lifecyclemp-pageMenu",
						JSON.stringify(pageMenu)
					);
				}
				callback && callback();
			})
			.catch((error) => {
				console.log("failed to get menu,the error message is: ", error);
			});
	};
	getIndex = () => {};
	getNotify = () => {
		let data = {
			type: "",
			isScroll: "1",
			beginTime: moment().subtract(365, "day").format(dateFormat),
			endTime: moment().format(dateFormat),
		};
		requestWithSignInJson({
			method: "POST",
			url: `${root}/notice/noticeList/1/100`,
			accessPage: getAccessPage({
				module: "通知公告",
				operation: "query",
			}),
			data,
		})
			.then((resp) => {
				this.setState({ notifies: resp.data.list || [] });
				let dom = document.getElementsByClassName("scrollContent")[0];
				let width = parseInt(dom.offsetWidth);
				dom.style.animationDuration = `${parseInt(width / 50)}s`;
				console.log(dom.offsetWidth, dom.style.animationDuration);
			})
			.catch((error) => {
				console.log(error);
				// alert("查询出错了~~~");
			});
	};
	gotoSubPage = (id) => {
		let token = localStorage.getItem("lifecyclemp-Access-User-Token");
		let login = () => {
			axios
				.get(`${systemManagerTobRest}/sso/applicationClient/S01668`)
				.then((resp) => {
					let { client_id, redirect_uri } = resp.data;
					if (client_id && redirect_uri) {
						let returnUrl = encodeURIComponent(window.location.href);
						window.location.href = `${loginUrl}/?responseType=code&client_id=${client_id}&redirect_uri=${redirect_uri}&returnUrl=${returnUrl}#/login`;
					}
				});
			// window.location.href = "/lifecyclemp/build/login.html";
		};
		if (!token) {
			Modal.warning({
				title: "提示",
				content: (
					<Fragment>
						<p>您尚未登录，请先登录。</p>
						<p>
							<a onClick={login}>点此登录</a>
						</p>
					</Fragment>
				),
				cancelText: "取消",
			});
		} else {
			if (id) {
				window.location.href = `/lifecyclemp/build/home.html?id=${id}`;
			} else {
				Modal.warning({
					title: "提示",
					content: (
						<Fragment>
							<p>您尚未申请该权限，请先</p>
							<p>
								<a href="https://ihaier.feishu.cn/share/base/form/shrcno4Nhll086CfYqnNwoBQILe">
									点此申请权限
								</a>
							</p>
						</Fragment>
					),
					cancelText: "取消",
				});
			}
		}
	};
}
export default React.forwardRef((props, ref) => <HomePage ref={ref} />);
